<template>
  <div>
    <div class="sixteentosix omt-6 omt-md-25 sixteentosix-wrap">
      <div class="new-background-wrap">
        <div
          class="kachelimage header-image zoom-image"
          style="
            background: url('/static/img/trainingrequest.jpg');
            background-position: top !important;
          "
        ></div>
        <!-- <img src="/static/img/video-main-banner.svg" /> -->
        <div class="headline-wrap">
          <div class="headline">
            <div class="text-subtitle-2 text-md-h5">{{ $t("sales-list") }}</div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb />
    <div>
      <div
        class="col-xl-12 right-side-block justify-content-right pr-3 s-list"
        id="buttons-custom-te"
      >
        <div class="s-list-btn">
          <v-btn
            :to="`/sales-request`"
            v-show="$rights.includes('CREATE_SALESLIST')"
            outlined
            depressed
            tile
            class="savebutton sales-list-buttons-1"
            ><img src="/static/img/event-plus.svg" class="mr-sm" />{{
              $t("create-sales-list")
            }}</v-btn
          >
          <v-btn
            :to="`/performance-board`"
            v-show="$rights.includes('VIEW_PERFORMANCE_BOARD')"
            outlined
            depressed
            tile
            class="savebutton sales-list-buttons-1"
            ><img class="mr-sm" src="../assets/icons/bar_ico.svg" />{{
              $t("view-performance-board")
            }}</v-btn
          >
          <v-btn
            :href="`/projects`"
            v-show="$rights.includes('VIEW_SALESLIST_PROJECT')"
            outlined
            depressed
            tile
            class="csv-export-btn project-sales-btn"
            >{{ $t("projects") }}</v-btn
          >

          <v-btn
            :href="`/api/saleslist/export`"
            v-show="$rights.includes('SALES_LIST_CSV_EXPORT')"
            outlined
            depressed
            tile
            class="csv-export-btn"
            ><img class="mr-sm" src="../assets/icons/download_ico.svg" />{{
              $t("export_csv")
            }}</v-btn
          >

          <v-btn
            v-if="columnSearch != null && filterTab"
            @click="clearFilters()"
            outlined
            depressed
            tile
            class="savebutton cl_filter_btn"
            ><v-icon>mdi-close</v-icon>{{ $t("clearFilters") }}</v-btn
          >
        </div>
        <v-tabs
          v-model="categoryTab"
          align-with-title
          touchless
          class="v-tabs s-list-tab pb-0 LanguageselectTabgroup sales-list-wrap v-tabs--align-with-title theme--light"
        >
          <v-tabs-slider color="indigo"></v-tabs-slider>

          <div class="event-tabbing-wrapper for_sale">
            <v-tab class="sales-tabbing" @click="clickFilterDropdown('I')">
              <div class="t_pack">
                {{ $t("incomplete") }}
                <span class="count-wrap"> {{ totalRecordsIncompleted }} </span>
              </div>
            </v-tab>
            <v-tab
              class="sales-tabbing sales-tabbing-margin"
              @click="clickFilterDropdown('C')"
            >
              <div class="t_pack">
                {{ $t("completed") }}
                <span class="count-wrap"> {{ totalRecordsCompleted }} </span>
              </div>
            </v-tab>

            <v-tab class="sales-tabbing" @click="clickFilterDropdown('A')">
              <div class="t_pack">
                {{ $t("all") }}
                <span class="count-wrap"> {{ totalRecords }} </span>
              </div>
            </v-tab>
          </div>
        </v-tabs>
      </div>
      <div>
        <v-tabs-items v-model="categoryTab" touchless>
          <!-- Tab 1 -->
          <v-tab-item class="grid-container sales_grid_container">
            <ag-grid-vue
              v-if="categoryTab === 0"
              class="sales-list-table-wrapper ag-theme-alpine ag-custom-te ag-custom-tbl tbl-scroll-lg"
              id="incompletedGrid"
              :key="'incompletedGrid'"
              :columnDefs="columnDefsIncompleted"
              @grid-ready="onGridReadyIncompleted"
              :rowData="rowDataIncompleted"
              :gridOptions="gridOptionsIncompleted"
              :domLayout="'normal'"
              :pinnedBottomRowData="pinnedBottomRowData"
              :rowClassRules="rowClassRules"
              :isFullWidthCell="isFullWidthCell"
              @onFilterChanged="onFilterChanged"
              @cell-clicked="onCellClicked"
              @firstDataRendered="onFirstDataRendered"
              :suppressCellSelection="true"
              :headerHeight="40"
              @sortChanged="onSortChangedIncomplete"
              :localeText="gridLocaleText"
            />
            <span class="sppn">
              {{ totalRecordsIncompleted > 0 ? pageIncompleted : 0 }} &nbsp;{{
                $t("of")
              }}&nbsp;{{ totalPagesIncompleted }} ({{
                totalRecordsIncompleted
              }}
              {{ $t("records") }})
            </span>
            <pagination
              class="my-2"
              :current-page="pageIncompleted"
              :total-pages="totalPagesIncompleted"
              :show-previous-page="previousPageIncompleted"
              :show-next-page="nextPageIncompleted"
              :show-current-page="showCurrentPageIncompleted"
            />
          </v-tab-item>

          <!-- Tab 2 -->
          <v-tab-item class="grid-container sales_grid_container">
            <ag-grid-vue
              v-if="categoryTab === 1"
              class="sales-list-table-wrapper ag-theme-alpine ag-custom-te ag-custom-tbl tbl-scroll-lg"
              id="completedGrid"
              :key="'completedGrid'"
              :columnDefs="columnDefsCompleted"
              @grid-ready="onGridReadyCompleted"
              :rowData="rowDataCompleted"
              :gridOptions="gridOptionsCompleted"
              :domLayout="'normal'"
              :pinnedBottomRowData="pinnedBottomRowData"
              :rowClassRules="rowClassRules"
              :isFullWidthCell="isFullWidthCell"
              @onFilterChanged="onFilterChanged"
              @cell-clicked="onCellClicked"
              @firstDataRendered="onFirstDataRendered"
              :suppressCellSelection="true"
              :headerHeight="40"
              @sortChanged="onSortChangedCompleted"
              :localeText="gridLocaleText"
            />
            <span class="sppn">
              {{ totalRecordsCompleted > 0 ? pageCompleted : 0 }} &nbsp;{{
                $t("of")
              }}&nbsp;{{ totalPagesCompleted }} ({{ totalRecordsCompleted }}
              {{ $t("records") }})
            </span>
            <pagination
              class="my-2"
              :current-page="pageCompleted"
              :total-pages="totalPagesCompleted"
              :show-previous-page="previousPageCompleted"
              :show-next-page="nextPageCompleted"
              :show-current-page="showCurrentPageCompleted"
            />
          </v-tab-item>

          <!-- Tab 3 -->
          <v-tab-item class="grid-container sales_grid_container">
            <ag-grid-vue
              v-if="categoryTab === 2"
              class="sales-list-table-wrapper ag-theme-alpine ag-custom-te ag-custom-tbl tbl-scroll-lg"
              id="allGrid"
              :key="'allGrid'"
              :columnDefs="columnDefs"
              @grid-ready="onGridReady"
              :rowData="rowData"
              :gridOptions="gridOptions"
              :domLayout="'normal'"
              :pinnedBottomRowData="pinnedBottomRowData"
              :rowClassRules="rowClassRules"
              :isFullWidthCell="isFullWidthCell"
              @onFilterChanged="onFilterChanged"
              @cell-clicked="onCellClicked"
              @firstDataRendered="onFirstDataRendered"
              :suppressCellSelection="true"
              :headerHeight="40"
              @sortChanged="onSortChanged"
              :localeText="gridLocaleText"
            />
            <span class="sppn">
              {{ totalRecords > 0 ? page : 0 }} &nbsp;{{ $t("of") }}&nbsp;{{
                totalPages
              }}
              ({{ totalRecords }} {{ $t("records") }})
            </span>
            <pagination
              class="my-2"
              :current-page="page"
              :total-pages="totalPages"
              :show-previous-page="previousPage"
              :show-next-page="nextPage"
              :show-current-page="showCurrentPage"
            />
          </v-tab-item>
        </v-tabs-items>
      </div>

      <!-- <Contact /> -->
    </div>
  </div>
</template>

<script>
import pagination from "./custom/pagination.vue";
import { AgGridVue } from "ag-grid-vue";
const _ = require("lodash");

import ColumnHeaderSearch from "./custom/ColumnHeaderSearch.vue";
import ColumnDateSearch from "./custom/ColumnDateSearch.vue";
import ColumnDateRangePicker from "./custom/ColumnDateRangePicker.vue";
import ColumnMonthSearch from "./custom/ColumnMonthSearch.vue";
import ColumnDropDownSearch from "./custom/ColumnDropDownSearch.vue";
import ColumnAutoCompleteSearch from "./custom/ColumnAutoCompleteSearch.vue";
import ColumnAutoCompleteSearchLocationManager from "./custom/ColumnAutoCompleteSearchLocationManager.vue";
import ColumnAutoCompleteSearchTenants from "./custom/ColumnAutoCompleteSearchTenants.vue";
import ColumnDropDownCompleteSearch from "./custom/ColumnDropDownCompleteSearch.vue";

import ColumnServiceOrderDropDownSearch from "./custom/ColumnServiceOrderDropDownSearch.vue";

import ColumnCountrySearch from "./custom/ColumnCountrySearch.vue";
import ColumnProcessingStatusSearch from "./custom/ColumnProcessingStatusSearch.vue";
import ColumnSalesSourceSearch from "./custom/ColumnSalesSourceSearch.vue";
import ColumnProjectNumberSearch from "./custom/ColumnProjectNumberSearch.vue";

import { eventBus } from "../main.js";
import Breadcrumb from "./Breadcrumbs.vue";
import ImageTextRenderer from "./ImageTextRenderer.vue";

export default {
  components: {
    AgGridVue,
    pagination,
    columnHeaderSearch: ColumnHeaderSearch,
    columnDateSearch: ColumnDateSearch,
    columnDateRangePicker: ColumnDateRangePicker,
    columnMonthSearch: ColumnMonthSearch,
    columnDropDownSearch: ColumnDropDownSearch,
    columnAutoCompleteSearch: ColumnAutoCompleteSearch,
    columnAutoCompleteSearchLocationManager:
      ColumnAutoCompleteSearchLocationManager,
    columnAutoCompleteSearchTenants: ColumnAutoCompleteSearchTenants,
    columnCountrySearch: ColumnCountrySearch,
    columnProcessingStatusSearch: ColumnProcessingStatusSearch,
    ColumnSalesSourceSearch: ColumnSalesSourceSearch,
    Breadcrumb,
    ImageTextRenderer,
    ColumnDropDownCompleteSearch: ColumnDropDownCompleteSearch,
    ColumnServiceOrderDropDownSearch: ColumnServiceOrderDropDownSearch,
    ColumnProjectNumberSearch: ColumnProjectNumberSearch,
  },
  computed: {
    gridLocaleText() {
      return {
        noRowsToShow: this.$t("noRowsToShow"),
      };
    },
    columnDefs() {
      return [
        {
          id: 1,
          order: 1,
          field: "eventNumber",
          cellRenderer: this.designationsFieldEventNumber,
          width: 150,
          wrapText: true,
          autoHeight: true,
          sortable: true,
          headerName: this.$t("eventNrsales"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "eventNumber",
          },
        },
        {
          id: 2,
          order: 2,
          field: "country",
          width: 140,
          wrapText: true,
          autoHeight: true,
          sortable: false,
          headerName: this.$t("country"),
          cellClass: "ag-cell ag-country",
          headerClass: "ag-cell",
          cellRendererFramework: "ImageTextRenderer",
          suppressMenu: true,
          filterFramework: "columnCountrySearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnCountrySearch",
          filterParams: {
            suppressFilterButton: true,
          },
          cellRendererParams: (params) => {
            // Dynamically retrieve values based on row data
            return {
              country: params.data.country, // From the row data
              editorName: params.data.editorName, // From the row data
            };
          },
          floatingFilterComponentParams: {
            columnHeader: "country",
          },
        },
        {
          id: 3,
          order: 3,
          field: "training",
          flex: 3,
          minWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellRenderer: this.designationsField,
          sortable: false,
          headerName: this.$t("training_salestable"),
          cellClass: "ag-cell cell_1",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "trainingnameSales",
          },
        },

        {
          id: 3,
          order: 3,
          field: "formattedSalesMonth",
          width: 140,
          wrapText: true,
          cellRenderer: this.getFormattedSalesMonth,
          autoHeight: true,
          sortable: false,
          headerName: this.$t("sales_month"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnMonthSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnMonthSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "salesMonth",
          },
        },
        //  {
        //   id: 4,
        //   order: 4,
        //   field: "formattedInquiryDate",
        //   width: 140,
        //   wrapText: true,
        //   autoHeight: true,
        //   sortable: false,
        //   headerName: this.$t("inquiry_date"),
        //   cellClass: "ag-cell ag_cell_center",
        //   headerClass: "ag-cell",
        //   suppressMenu: true,
        //   filterFramework: "columnDateSearch",
        //   suppressMovable: true,
        //   floatingFilter: true,
        //   floatingFilterComponent: "columnDateSearch",
        //   filterParams: {
        //     suppressFilterButton: true,
        //   },
        //   floatingFilterComponentParams: {
        //     columnHeader: "inquiryDate",
        //   },
        // },

        {
          id: 5,
          order: 5,
          field: "salesSource",
          width: 140,
          wrapText: true,
          autoHeight: true,
          sortable: false,
          headerName: this.$t("stake_holder"),
          cellClass: "ag-cell ag_cell_center",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "ColumnSalesSourceSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "ColumnSalesSourceSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "salesSource",
          },
        },
        {
          id: 5,
          order: 5,
          field: "project.projectNumber",
          cellRenderer: this.getProjectNumer,
          width: 140,
          wrapText: true,
          autoHeight: true,
          sortable: false,
          headerName: this.$t("project_number"),
          cellClass: "ag-cell ag_cell_center",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "ColumnProjectNumberSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "ColumnProjectNumberSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "project.projectNumber",
          },
        },
        {
          id: 6,
          order: 6,
          field: "formattedOrderDate",
          width: 210,
          sortable: false,
          wrapText: true,
          autoHeight: true,
          headerName: this.$t("inquiry_date"),
          cellClass: "ag-cell ag_cell_center",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnDateRangePicker",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnDateRangePicker",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "orderDate",
          },
        },
        {
          id: 7,
          order: 7,
          width: 200,
          wrapText: true,
          autoHeight: true,
          field: "formattedProcessingSatatus",
          sortable: false,
          headerName: this.$t("processing-status"),
          cellClass: "ag-cell ag_cell_center ag_cell_status",
          headerClass: "ag-cell",
          cellRenderer: this.getStatusWithHighlight,
          suppressMenu: true,
          filterFramework: "columnProcessingStatusSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnProcessingStatusSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "processingStatus",
          },
          cellClassRules: {
            "in-progress-status": (params) => params.value === "In_progress",
            "open-status": (params) => params.value === "Open",
            "operations-status": (params) => params.value === "Operations",
            "offersent-status": (params) => params.value === "Offer_sent",
            "quotation-status": (params) => params.value === "Quotation",
            "orderreceived-status": (params) =>
              params.value === "Order_received",
            "onhold-status": (params) => params.value === "On_hold",
            "invoicing-status": (params) => params.value === "Invoicing",
            "opentraining-status": (params) => params.value === "Open_training",
            Invoice_created: (params) => params.value === "Invoice_created",
          },
        },
        {
          id: 8,
          order: 8,
          wrapText: true,
          width: 160,
          autoHeight: true,
          field: "salesContactPersons",
          sortable: false,
          headerName: this.$t("sales_contact"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnAutoCompleteSearchLocationManager",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnAutoCompleteSearchLocationManager",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "salesContact",
          },
        },
        //   {
        //   id: 9,
        //   order: 9,
        //   wrapText: true,
        //   autoHeight: true,
        //   field: "projectNumber",
        //   width: 140,
        //   sortable: false,
        //   headerName: this.$t("project_number"),
        //   cellClass: "ag-cell",
        //   headerClass: "ag-cell",
        //   suppressMenu: true,
        //   filterFramework: "columnHeaderSearch",
        //   suppressMovable: true,
        //   floatingFilter: true,
        //   floatingFilterComponent: "columnHeaderSearch",
        //   filterParams: {
        //     suppressFilterButton: true,
        //   },
        //   floatingFilterComponentParams: {
        //     columnHeader: "projectNumber",
        //   },
        // },
        {
          id: 10,
          order: 10,
          wrapText: true,
          autoHeight: true,
          field: "debtorNumber",
          width: 140,
          sortable: false,
          headerName: this.$t("debtor_number"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "debtorNumber",
          },
        },
        {
          id: 11,
          order: 11,
          wrapText: true,
          autoHeight: true,
          field: "customer",
          width: 240,
          sortable: false,
          headerName: this.$t("customer"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnAutoCompleteSearchTenants",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnAutoCompleteSearchTenants",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "customer",
          },
        },
        {
          id: 12,
          order: 12,
          wrapText: true,
          autoHeight: true,
          field: "serviceOrder",
          width: 180,
          sortable: false,
          headerName: this.$t("service_order"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "ColumnServiceOrderDropDownSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "ColumnServiceOrderDropDownSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "serviceOrder",
          },
        },
        {
          id: 13,
          order: 13,
          wrapText: true,
          autoHeight: true,
          field: "offerNumber",
          width: 135,
          sortable: false,
          headerName: this.$t("offer_number"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "offerNumber",
          },
        },

        {
          id: 14,
          order: 14,
          wrapText: true,
          autoHeight: true,
          field: "offerAmount",
          cellRenderer: this.getOfferAmount,
          width: 125,
          sortable: false,
          headerName: this.$t("offer_amount"),
          cellClass: "ag-cell ag_cell_right",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "offerAmount",
          },
          // valueFormatter: params => this.currencyFormatter(params.value, "€"),
        },
        {
          id: 15,
          order: 15,
          wrapText: true,
          autoHeight: true,
          field: "formattedEffectiveDate",
          width: 135,
          sortable: false,
          headerName: this.$t("effective_date"),
          cellClass: "ag-cell ag_cell_center",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnDateSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnDateSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "effectiveDate",
          },
        },

        {
          id: 16,
          order: 16,
          wrapText: true,
          autoHeight: true,
          field: "formattedDateOfInvoice",
          width: 135,
          sortable: false,
          headerName: this.$t("date_of_invoice"),
          cellClass: "ag-cell ag_cell_center",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnDateSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnDateSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "dateOfInvoice",
          },
        },

        {
          id: 17,
          order: 17,
          wrapText: true,
          autoHeight: true,
          field: "invoiceAmount",
          width: 140,
          cellRenderer: this.getInvoiceAmount,
          sortable: false,
          headerName: this.$t("invoice_amount"),
          cellClass: "ag-cell ag_cell_right",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "invoiceAmount",
          },
          //valueFormatter: params => this.currencyFormatter(params.value, "€"),
        },
        {
          id: 18,
          order: 18,
          wrapText: true,
          autoHeight: true,
          field: "billNumber",
          width: 140,
          sortable: false,
          headerName: this.$t("bill_number"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "billNumber",
          },
        },
      ];
    },
    columnDefsCompleted() {
      return [
        {
          id: 1,
          order: 1,
          field: "eventNumber",
          cellRenderer: this.designationsFieldEventNumber,
          width: 150,
          wrapText: true,
          autoHeight: true,
          sortable: true,
          headerName: this.$t("eventNrsales"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "eventNumber",
          },
        },
        {
          id: 2,
          order: 2,
          field: "country",
          width: 140,
          wrapText: true,
          autoHeight: true,
          sortable: false,
          headerName: this.$t("country"),
          cellClass: "ag-cell ag-country",
          headerClass: "ag-cell",
          cellRendererFramework: "ImageTextRenderer",
          suppressMenu: true,
          filterFramework: "columnCountrySearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnCountrySearch",
          filterParams: {
            suppressFilterButton: true,
          },
          cellRendererParams: (params) => {
            // Dynamically retrieve values based on row data
            return {
              country: params.data.country, // From the row data
              editorName: params.data.editorName, // From the row data
            };
          },
          floatingFilterComponentParams: {
            columnHeader: "country",
          },
        },
        {
          id: 3,
          order: 3,
          field: "training",
          flex: 3,
          minWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellRenderer: this.designationsField,
          sortable: false,
          headerName: this.$t("training_salestable"),
          cellClass: "ag-cell cell_1",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "trainingnameSales",
          },
        },

        {
          id: 3,
          order: 3,
          field: "formattedSalesMonth",
          width: 140,
          wrapText: true,
          cellRenderer: this.getFormattedSalesMonth,
          autoHeight: true,
          sortable: false,
          headerName: this.$t("sales_month"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnMonthSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnMonthSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "salesMonth",
          },
        },
        //  {
        //   id: 4,
        //   order: 4,
        //   field: "formattedInquiryDate",
        //   width: 140,
        //   wrapText: true,
        //   autoHeight: true,
        //   sortable: false,
        //   headerName: this.$t("inquiry_date"),
        //   cellClass: "ag-cell ag_cell_center",
        //   headerClass: "ag-cell",
        //   suppressMenu: true,
        //   filterFramework: "columnDateSearch",
        //   suppressMovable: true,
        //   floatingFilter: true,
        //   floatingFilterComponent: "columnDateSearch",
        //   filterParams: {
        //     suppressFilterButton: true,
        //   },
        //   floatingFilterComponentParams: {
        //     columnHeader: "inquiryDate",
        //   },
        // },

        {
          id: 5,
          order: 5,
          field: "salesSource",
          width: 140,
          wrapText: true,
          autoHeight: true,
          sortable: false,
          headerName: this.$t("stake_holder"),
          cellClass: "ag-cell ag_cell_center",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "ColumnSalesSourceSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "ColumnSalesSourceSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "salesSource",
          },
        },
        {
          id: 5,
          order: 5,
          field: "project.projectNumber",
          width: 140,
          wrapText: true,
          autoHeight: true,
          cellRenderer: this.getProjectNumer,
          sortable: false,
          headerName: this.$t("project_number"),
          cellClass: "ag-cell ag_cell_center",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "ColumnProjectNumberSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "ColumnProjectNumberSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "project.projectNumber",
          },
        },
        {
          id: 6,
          order: 6,
          field: "formattedOrderDate",
          width: 210,
          sortable: false,
          wrapText: true,
          autoHeight: true,
          headerName: this.$t("inquiry_date"),
          cellClass: "ag-cell ag_cell_center",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnDateRangePicker",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnDateRangePicker",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "orderDate",
          },
        },
        {
          id: 7,
          order: 7,
          width: 210,
          wrapText: true,
          autoHeight: true,
          field: "formattedProcessingSatatus",
          sortable: false,
          headerName: this.$t("processing-status"),
          cellClass: "ag-cell ag_cell_center ag_cell_status",
          headerClass: "ag-cell",
          cellRenderer: this.getStatusWithHighlight,
          suppressMenu: true,
          filterFramework: "columnProcessingStatusSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnProcessingStatusSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "processingStatus",
          },
          cellClassRules: {
            "in-progress-status": (params) => params.value === "In_progress",
            "open-status": (params) => params.value === "Open",
            "operations-status": (params) => params.value === "Operations",
            "offersent-status": (params) => params.value === "Offer_sent",
            "quotation-status": (params) => params.value === "Quotation",
            "orderreceived-status": (params) =>
              params.value === "Order_received",
            "onhold-status": (params) => params.value === "On_hold",
            "invoicing-status": (params) => params.value === "Invoicing",
            "opentraining-status": (params) => params.value === "Open_training",
            Invoice_created: (params) => params.value === "Invoice_created",
          },
        },
        {
          id: 8,
          order: 8,
          wrapText: true,
          width: 160,
          autoHeight: true,
          field: "salesContactPersons",
          sortable: false,
          headerName: this.$t("sales_contact"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnAutoCompleteSearchLocationManager",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnAutoCompleteSearchLocationManager",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "salesContact",
          },
        },
        //   {
        //   id: 9,
        //   order: 9,
        //   wrapText: true,
        //   autoHeight: true,
        //   field: "projectNumber",
        //   width: 140,
        //   sortable: false,
        //   headerName: this.$t("project_number"),
        //   cellClass: "ag-cell",
        //   headerClass: "ag-cell",
        //   suppressMenu: true,
        //   filterFramework: "columnHeaderSearch",
        //   suppressMovable: true,
        //   floatingFilter: true,
        //   floatingFilterComponent: "columnHeaderSearch",
        //   filterParams: {
        //     suppressFilterButton: true,
        //   },
        //   floatingFilterComponentParams: {
        //     columnHeader: "projectNumber",
        //   },
        // },
        {
          id: 10,
          order: 10,
          wrapText: true,
          autoHeight: true,
          field: "debtorNumber",
          width: 140,
          sortable: false,
          headerName: this.$t("debtor_number"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "debtorNumber",
          },
        },
        {
          id: 11,
          order: 11,
          wrapText: true,
          autoHeight: true,
          field: "customer",
          width: 240,
          sortable: false,
          headerName: this.$t("customer"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnAutoCompleteSearchTenants",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnAutoCompleteSearchTenants",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "customer",
          },
        },
        {
          id: 12,
          order: 12,
          wrapText: true,
          autoHeight: true,
          field: "serviceOrder",
          width: 180,
          sortable: false,
          headerName: this.$t("service_order"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "ColumnServiceOrderDropDownSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "ColumnServiceOrderDropDownSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "serviceOrder",
          },
        },
        {
          id: 13,
          order: 13,
          wrapText: true,
          autoHeight: true,
          field: "offerNumber",
          width: 135,
          sortable: false,
          headerName: this.$t("offer_number"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "offerNumber",
          },
        },

        {
          id: 14,
          order: 14,
          wrapText: true,
          autoHeight: true,
          field: "offerAmount",
          cellRenderer: this.getOfferAmount,
          width: 125,
          sortable: false,
          headerName: this.$t("offer_amount"),
          cellClass: "ag-cell ag_cell_right",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "offerAmount",
          },
          // valueFormatter: params => this.currencyFormatter(params.value, "€"),
        },
        {
          id: 15,
          order: 15,
          wrapText: true,
          autoHeight: true,
          field: "formattedEffectiveDate",
          width: 135,
          sortable: false,
          headerName: this.$t("effective_date"),
          cellClass: "ag-cell ag_cell_center",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnDateSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnDateSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "effectiveDate",
          },
        },

        {
          id: 16,
          order: 16,
          wrapText: true,
          autoHeight: true,
          field: "formattedDateOfInvoice",
          width: 135,
          sortable: false,
          headerName: this.$t("date_of_invoice"),
          cellClass: "ag-cell ag_cell_center",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnDateSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnDateSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "dateOfInvoice",
          },
        },

        {
          id: 17,
          order: 17,
          wrapText: true,
          autoHeight: true,
          field: "invoiceAmount",
          width: 140,
          cellRenderer: this.getInvoiceAmount,
          sortable: false,
          headerName: this.$t("invoice_amount"),
          cellClass: "ag-cell ag_cell_right",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "invoiceAmount",
          },
          //valueFormatter: params => this.currencyFormatter(params.value, "€"),
        },
        {
          id: 18,
          order: 18,
          wrapText: true,
          autoHeight: true,
          field: "billNumber",
          width: 140,
          sortable: false,
          headerName: this.$t("bill_number"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "billNumber",
          },
        },
      ];
    },
    columnDefsIncompleted() {
      return [
        {
          id: 1,
          order: 1,
          field: "eventNumber",
          cellRenderer: this.designationsFieldEventNumber,
          width: 150,
          wrapText: true,
          autoHeight: true,
          sortable: true,
          headerName: this.$t("eventNrsales"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "eventNumber",
          },
        },
        {
          id: 2,
          order: 2,
          field: "country",
          width: 140,
          wrapText: true,
          autoHeight: true,
          sortable: false,
          headerName: this.$t("country"),
          cellClass: "ag-cell ag-country",
          headerClass: "ag-cell",
          cellRendererFramework: "ImageTextRenderer",
          suppressMenu: true,
          filterFramework: "columnCountrySearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnCountrySearch",
          filterParams: {
            suppressFilterButton: true,
          },
          cellRendererParams: (params) => {
            // Dynamically retrieve values based on row data
            return {
              country: params.data.country, // From the row data
              editorName: params.data.editorName, // From the row data
            };
          },
          floatingFilterComponentParams: {
            columnHeader: "country",
          },
        },
        {
          id: 3,
          order: 3,
          field: "training",
          flex: 3,
          minWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellRenderer: this.designationsField,
          sortable: false,
          headerName: this.$t("training_salestable"),
          cellClass: "ag-cell cell_1",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "trainingnameSales",
          },
        },

        {
          id: 3,
          order: 3,
          field: "formattedSalesMonth",
          width: 140,
          wrapText: true,
          cellRenderer: this.getFormattedSalesMonth,
          autoHeight: true,
          sortable: true,
          headerName: this.$t("sales_month"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnMonthSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnMonthSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "salesMonth",
          },
        },
        //  {
        //   id: 4,
        //   order: 4,
        //   field: "formattedInquiryDate",
        //   width: 140,
        //   wrapText: true,
        //   autoHeight: true,
        //   sortable: false,
        //   headerName: this.$t("inquiry_date"),
        //   cellClass: "ag-cell ag_cell_center",
        //   headerClass: "ag-cell",
        //   suppressMenu: true,
        //   filterFramework: "columnDateSearch",
        //   suppressMovable: true,
        //   floatingFilter: true,
        //   floatingFilterComponent: "columnDateSearch",
        //   filterParams: {
        //     suppressFilterButton: true,
        //   },
        //   floatingFilterComponentParams: {
        //     columnHeader: "inquiryDate",
        //   },
        // },

        {
          id: 5,
          order: 5,
          field: "salesSource",
          width: 140,
          wrapText: true,
          autoHeight: true,
          sortable: false,
          headerName: this.$t("stake_holder"),
          cellClass: "ag-cell ag_cell_center",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "ColumnSalesSourceSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "ColumnSalesSourceSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "salesSource",
          },
        },
        {
          id: 5,
          order: 5,
          field: "project.projectNumber",
          cellRenderer: this.getProjectNumer,
          width: 140,
          wrapText: true,
          autoHeight: true,
          sortable: false,
          headerName: this.$t("project_number"),
          cellClass: "ag-cell ag_cell_center",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "ColumnProjectNumberSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "ColumnProjectNumberSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "project.projectNumber",
          },
        },
        {
          id: 6,
          order: 6,
          field: "formattedOrderDate",
          width: 210,
          sortable: true,
          wrapText: true,
          autoHeight: true,
          headerName: this.$t("inquiry_date"),
          cellClass: "ag-cell ag_cell_center",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnDateRangePicker",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnDateRangePicker",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "orderDate",
          },
        },
        {
          id: 7,
          order: 7,
          width: 210,
          wrapText: true,
          autoHeight: true,
          field: "formattedProcessingSatatus",
          sortable: false,
          headerName: this.$t("processing-status"),
          cellClass: "ag-cell ag_cell_center ag_cell_status",
          headerClass: "ag-cell",
          cellRenderer: this.getStatusWithHighlight,
          suppressMenu: true,
          filterFramework: "columnProcessingStatusSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnProcessingStatusSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "processingStatus",
          },
          cellClassRules: {
            "in-progress-status": (params) => params.value === "In_progress",
            "open-status": (params) => params.value === "Open",
            "operations-status": (params) => params.value === "Operations",
            "offersent-status": (params) => params.value === "Offer_sent",
            "quotation-status": (params) => params.value === "Quotation",
            "orderreceived-status": (params) =>
              params.value === "Order_received",
            "onhold-status": (params) => params.value === "On_hold",
            "invoicing-status": (params) => params.value === "Invoicing",
            "opentraining-status": (params) => params.value === "Open_training",
            Invoice_created: (params) => params.value === "Invoice_created",
          },
        },
        {
          id: 8,
          order: 8,
          wrapText: true,
          width: 160,
          autoHeight: true,
          field: "salesContactPersons",
          sortable: false,
          headerName: this.$t("sales_contact"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnAutoCompleteSearchLocationManager",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnAutoCompleteSearchLocationManager",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "salesContact",
          },
        },
        //   {
        //   id: 9,
        //   order: 9,
        //   wrapText: true,
        //   autoHeight: true,
        //   field: "projectNumber",
        //   width: 140,
        //   sortable: false,
        //   headerName: this.$t("project_number"),
        //   cellClass: "ag-cell",
        //   headerClass: "ag-cell",
        //   suppressMenu: true,
        //   filterFramework: "columnHeaderSearch",
        //   suppressMovable: true,
        //   floatingFilter: true,
        //   floatingFilterComponent: "columnHeaderSearch",
        //   filterParams: {
        //     suppressFilterButton: true,
        //   },
        //   floatingFilterComponentParams: {
        //     columnHeader: "projectNumber",
        //   },
        // },
        {
          id: 10,
          order: 10,
          wrapText: true,
          autoHeight: true,
          field: "debtorNumber",
          width: 140,
          sortable: false,
          headerName: this.$t("debtor_number"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "debtorNumber",
          },
        },
        {
          id: 11,
          order: 11,
          wrapText: true,
          autoHeight: true,
          field: "customer",
          width: 240,
          sortable: false,
          headerName: this.$t("customer"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnAutoCompleteSearchTenants",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnAutoCompleteSearchTenants",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "customer",
          },
        },
        {
          id: 12,
          order: 12,
          wrapText: true,
          autoHeight: true,
          field: "serviceOrder",
          width: 180,
          sortable: false,
          headerName: this.$t("service_order"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "ColumnServiceOrderDropDownSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "ColumnServiceOrderDropDownSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "serviceOrder",
          },
        },
        {
          id: 13,
          order: 13,
          wrapText: true,
          autoHeight: true,
          field: "offerNumber",
          width: 135,
          sortable: false,
          headerName: this.$t("offer_number"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "offerNumber",
          },
        },

        {
          id: 14,
          order: 14,
          wrapText: true,
          autoHeight: true,
          field: "offerAmount",
          cellRenderer: this.getOfferAmount,
          width: 125,
          sortable: false,
          headerName: this.$t("offer_amount"),
          cellClass: "ag-cell ag_cell_right",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "offerAmount",
          },
          // valueFormatter: params => this.currencyFormatter(params.value, "€"),
        },
        {
          id: 15,
          order: 15,
          wrapText: true,
          autoHeight: true,
          field: "formattedEffectiveDate",
          width: 135,
          sortable: false,
          headerName: this.$t("effective_date"),
          cellClass: "ag-cell ag_cell_center",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnDateSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnDateSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "effectiveDate",
          },
        },

        {
          id: 16,
          order: 16,
          wrapText: true,
          autoHeight: true,
          field: "formattedDateOfInvoice",
          width: 135,
          sortable: false,
          headerName: this.$t("date_of_invoice"),
          cellClass: "ag-cell ag_cell_center",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnDateSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnDateSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "dateOfInvoice",
          },
        },

        {
          id: 17,
          order: 17,
          wrapText: true,
          autoHeight: true,
          field: "invoiceAmount",
          width: 140,
          cellRenderer: this.getInvoiceAmount,
          sortable: false,
          headerName: this.$t("invoice_amount"),
          cellClass: "ag-cell ag_cell_right",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "invoiceAmount",
          },
          //valueFormatter: params => this.currencyFormatter(params.value, "€"),
        },
        {
          id: 18,
          order: 18,
          wrapText: true,
          autoHeight: true,
          field: "billNumber",
          width: 140,
          sortable: false,
          headerName: this.$t("bill_number"),
          cellClass: "ag-cell",
          headerClass: "ag-cell",
          suppressMenu: true,
          filterFramework: "columnHeaderSearch",
          suppressMovable: true,
          floatingFilter: true,
          floatingFilterComponent: "columnHeaderSearch",
          filterParams: {
            suppressFilterButton: true,
          },
          floatingFilterComponentParams: {
            columnHeader: "billNumber",
          },
        },
      ];
    },
  },

  data() {
    return {
      filterTab: false,
      categoryTab: 0,
      locationManagers: null,
      stickyThreshold: 750, // Adjust this value if needed
      totalRecords: 0,
      totalRecordsCompleted: 0,
      totalRecordsIncompleted: 0,
      currentPageRecordCount: 0,
      salesSource: null,
      eventNumber: null,
      salesMonth: null,
      country: null,
      serialNumber: null,
      trainingName: null,
      customerName: null,
      orderDate: null,
      salesContact: null,
      processingStatus: null,
      page: 1,
      totalPages: 1,

      pageCompleted: 1,
      totalPagesCompleted: 1,

      pageIncompleted: 1,
      totalPagesIncompleted: 1,

      gridApi: null,
      gridApiCompleted: null,
      gridApiIncompleted: null,
      columnApi: null,
      rowData: [],
      rowDataCompleted: [],
      rowDataIncompleted: [],
      pinnedBottomRowData: null,
      rowClassRules: null,
      isFullWidthCell: null,
      frameworkComponents: null,
      gridOptions: {
        suppressContextMenu: false,
        rowModelType: "clientSide",
        suppressMovableColumns: true, // Suppress column shifting

        rowClass: "custom-row",
        suppressMenuHide: true,
        enableColResize: true,
        ensureDomOrder: true,
        defaultColDef: {
          resizable: true,
          minWidth: 150,
        },
      },
      gridOptionsCompleted: {
        suppressContextMenu: false,
        rowModelType: "clientSide",
        suppressMovableColumns: true, // Suppress column shifting

        rowClass: "custom-row",
        suppressMenuHide: true,
        enableColResize: true,
        ensureDomOrder: true,
        defaultColDef: {
          resizable: true,
          minWidth: 150,
        },
      },
      gridOptionsIncompleted: {
        suppressContextMenu: false,
        rowModelType: "clientSide",
        suppressMovableColumns: true, // Suppress column shifting

        rowClass: "custom-row",
        suppressMenuHide: true,
        enableColResize: true,
        ensureDomOrder: true,
        defaultColDef: {
          resizable: true,
          minWidth: 150,
        },
      },
      ElementPerPage: 50,
      sort: null,
      order: true,
      routes: {
        salesList: "/api/saleslist",
      },
      search: "",
      rules: [(value) => !!value || this.$t("required")],
      salesList: [],
      roles: [],
      createTrainingRequestPopup: false,
      menu: false,
      createmode: true,
      columnHeader: null,
      columnSearch: null,

      // Personal Data
      me: null,
      dtOrder: "I",
    };
  },

  watch: {
    categoryTab() {
      this.$nextTick(() => {
        this.initializeScrollbar();
      });
    },
  },

  mounted() {
    window.addEventListener("resize", this.onResize);

    const gridContainer = this.$el.querySelector(".grid-container");
    const gridBody = this.$el.querySelector(
      ".v-window-item.v-window-item--active .ag-root"
    );
    const horizontalScrollbar = this.$el.querySelector(
      ".v-window-item.v-window-item--active .ag-body-horizontal-scroll"
    );
    const threshold = 100; // Distance from bottom to switch to relative position

    const initializeScrollbar = () => {
      const threshold = 100;
      const footerHeight = 50;
      const updateScrollbarPosition = () => {
        requestAnimationFrame(() => {
          const rect = gridContainer.getBoundingClientRect();
          const windowHeight = window.innerHeight;
          const pageBottom = document.documentElement.scrollHeight;
          const scrollPosition = Math.round(window.scrollY + windowHeight); // Prevent minor flickers

          if (scrollPosition < pageBottom - footerHeight) {
            if (!horizontalScrollbar.classList.contains("sticky-scrollbar")) {
              horizontalScrollbar.style.display = "block";
              horizontalScrollbar.classList.add("sticky-scrollbar");
              horizontalScrollbar.classList.remove("relative-scrollbar");
              horizontalScrollbar.style.bottom = "0px";
            }
          } else {
            if (!horizontalScrollbar.classList.contains("relative-scrollbar")) {
              horizontalScrollbar.classList.add("relative-scrollbar");
              horizontalScrollbar.classList.remove("sticky-scrollbar");
              horizontalScrollbar.style.bottom =
                window.innerWidth > 1024 ? "40px" : "0px";
            }
          }
        });
      };

      // Ensure this function runs efficiently
      window.addEventListener("scroll", updateScrollbarPosition);

      window.addEventListener("resize", updateScrollbarPosition); // Adjust on resize

      const synchronizeScroll = (event) => {
        gridBody.scrollLeft = event.target.scrollLeft;
      };

      const throttle = (func, limit) => {
        let lastFunc;
        let lastRan;
        return function () {
          const context = this;
          const args = arguments;
          if (!lastRan) {
            func.apply(context, args);
            lastRan = Date.now();
          } else {
            clearTimeout(lastFunc);
            lastFunc = setTimeout(() => {
              if (Date.now() - lastRan >= limit) {
                func.apply(context, args);
                lastRan = Date.now();
              }
            }, limit - (Date.now() - lastRan));
          }
        };
      };

      // Add event listeners
      window.addEventListener("scroll", throttle(updateScrollbarPosition, 100));
      window.addEventListener("resize", () => {
        horizontalScrollbar.style.width = `${gridBody.scrollWidth}px`;
        updateScrollbarPosition();
      });
      horizontalScrollbar.addEventListener("scroll", synchronizeScroll);

      // Initialize scrollbar width and update position after the DOM is fully loaded
      horizontalScrollbar.style.width = `${gridBody.scrollWidth}px`;
      updateScrollbarPosition();
    };

    const observer = new MutationObserver((mutations, obs) => {
      if (gridContainer && gridBody && horizontalScrollbar) {
        initializeScrollbar();
        obs.disconnect();
      }
    });

    observer.observe(document, {
      childList: true,
      subtree: true,
    });

    window.addEventListener("scroll", this.handlePageScroll);

    if (
      !sessionStorage.getItem("salesMonth") &&
      !sessionStorage.getItem("salesContact") &&
      !sessionStorage.getItem("customer") &&
      !sessionStorage.getItem("salesCountry") &&
      !sessionStorage.getItem("orderDate") &&
      !sessionStorage.getItem("effectiveDate") &&
      !sessionStorage.getItem("dateOfInvoice") &&
      !sessionStorage.getItem("eventNumber") &&
      !sessionStorage.getItem("billNumber") &&
      !sessionStorage.getItem("invoiceAmount") &&
      !sessionStorage.getItem("offerAmount") &&
      !sessionStorage.getItem("offerNumber") &&
      !sessionStorage.getItem("debtorNumber") &&
      !sessionStorage.getItem("processingStatus") &&
      !sessionStorage.getItem("salesSource") &&
      !sessionStorage.getItem("serviceOrder") &&
      !sessionStorage.getItem("projectNumberText") &&
      !sessionStorage.getItem("trainingnameSales")
    ) {
      sessionStorage.removeItem("filter");
      this.filterTab = false;
    } else {
      this.filterTab = true;
      sessionStorage.setItem("filter", "filter");
    }

    if (
      sessionStorage.getItem("activeTab") == "I" &&
      sessionStorage.getItem("filter")
    ) {
      this.dtOrder = "I";
      this.categoryTab = 0;
      this.filterTab = true;
      this.columnSearch = true;
      this.getfiltteredData_inprogress();
      this.fetchSalesListCompletedNoFilter();
      this.fetchSalesListNoFilter();
    } else if (
      sessionStorage.getItem("activeTab") == "C" &&
      sessionStorage.getItem("filter")
    ) {
      this.categoryTab = 1;
      this.filterTab = true;
      this.columnSearch = true;
      this.dtOrder = "C";
      this.getfiltteredData_completed();
      this.fetchSalesListIncompletedNoFilter();
      this.fetchSalesListNoFilter();
    } else if (
      sessionStorage.getItem("activeTab") == "A" &&
      sessionStorage.getItem("filter")
    ) {
      console.log(this.columnSearch);
      this.columnSearch = true;
      this.categoryTab = 2;
      this.dtOrder = "A";
      this.filterTab = true;
      this.getfiltteredData_all();
      this.fetchSalesListIncompletedNoFilter();
      this.fetchSalesListCompletedNoFilter();
    } else if (
      !sessionStorage.getItem("activeTab") &&
      sessionStorage.getItem("filter")
    ) {
      this.categoryTab = 0;
      this.filterTab = true;
      this.dtOrder = "I";
      this.columnSearch = true;
      this.getfiltteredData_inprogress();
      this.fetchSalesListCompletedNoFilter();
      this.fetchSalesListNoFilter();
    } else {
      this.categoryTab = 0;
      this.filterTab = false;
      this.columnSearch = false;
      this.fetchSalesListCompletedNoFilter();
      this.fetchSalesListIncompletedNoFilter();
      this.fetchSalesListNoFilter();
    }
  },

  methods: {
    onSortChanged(event) {
      const allColumns = event.columnApi.getAllColumns();
      const sortableColumns = allColumns.filter(
        (col) => col.getColDef().sortable
      );

      if (sortableColumns.length > 0) {
        this.sortIncompleted = "";
        this.orderIncompleted = "";
        const sortedCol = sortableColumns.find((col) => col.getSort());
        if (sortedCol) {
          const sortState = sortedCol.getSort();
          let sortField = sortedCol.getColId();
          const sortOrder = sortState === "asc" ? "ASC" : "DESC";

          if (sortField == "formattedSalesMonth") {
            sortField = "salesMonth";
          }
          if (sortField == "formattedOrderDate") {
            sortField = "orderDate";
          }
          this.sortAll = sortField;
          this.orderAll = sortOrder === "ASC";
          this.pageAll = 1;
          this.fetchSalesList();
        }
      }
    },
    onSortChangedIncomplete(event) {
      const allColumns = event.columnApi.getAllColumns();
      const sortableColumns = allColumns.filter(
        (col) => col.getColDef().sortable
      );

      if (sortableColumns.length > 0) {
        this.sortIncompleted = "";
        this.orderIncompleted = "";
        const sortedCol = sortableColumns.find((col) => col.getSort());
        if (sortedCol) {
          const sortState = sortedCol.getSort();
          let sortField = sortedCol.getColId();
          const sortOrder = sortState === "asc" ? "ASC" : "DESC";

          if (sortField == "formattedSalesMonth") {
            sortField = "salesMonth";
          }
          if (sortField == "formattedOrderDate") {
            sortField = "orderDate";
          }
          this.sortIncompleted = sortField;
          this.orderIncompleted = sortOrder === "ASC";
          this.pageInompleted = 1;
          this.fetchSalesListIncompleted();
        }
      }
    },
    onSortChangedCompleted(event) {
      const allColumns = event.columnApi.getAllColumns();
      const sortableColumns = allColumns.filter(
        (col) => col.getColDef().sortable
      );

      if (sortableColumns.length > 0) {
        this.sortIncompleted = "";
        this.orderIncompleted = "";
        const sortedCol = sortableColumns.find((col) => col.getSort());
        if (sortedCol) {
          const sortState = sortedCol.getSort();
          let sortField = sortedCol.getColId();
          const sortOrder = sortState === "asc" ? "ASC" : "DESC";

          if (sortField == "formattedSalesMonth") {
            sortField = "salesMonth";
          }
          if (sortField == "formattedOrderDate") {
            sortField = "orderDate";
          }
          this.sortCompleted = sortField;
          this.orderCompleted = sortOrder === "ASC";
          this.pageCompleted = 1;
          this.fetchSalesListCompleted();
        }
      }
    },

    getProjectNumer(params) {
      if (params.data.project) {
        return params.data.project.projectNumber;
      } else if (params.data.projectText) {
        return params.data.projectText;
      } else {
        return "";
      }
    },

    getfiltteredData_inprogress() {
      this.eventNumber =
        !sessionStorage.getItem("eventNumber") ||
        sessionStorage.getItem("eventNumber").trim() === ""
          ? null
          : sessionStorage.getItem("eventNumber");

      this.country =
        !sessionStorage.getItem("salesCountry") ||
        sessionStorage.getItem("salesCountry").trim() === ""
          ? null
          : sessionStorage.getItem("salesCountry");

      this.salesMonth =
        !sessionStorage.getItem("salesMonth") ||
        sessionStorage.getItem("salesMonth").trim() === ""
          ? null
          : sessionStorage.getItem("salesMonth");

      this.salesSource =
        !sessionStorage.getItem("salesSource") ||
        sessionStorage.getItem("salesSource").trim() === ""
          ? null
          : sessionStorage.getItem("salesSource");

      this.orderDate =
        !sessionStorage.getItem("orderDate") ||
        sessionStorage.getItem("orderDate").trim() === ""
          ? null
          : sessionStorage.getItem("orderDate");

      this.processingStatus =
        !sessionStorage.getItem("processingStatus") ||
        sessionStorage.getItem("processingStatus").trim() === ""
          ? null
          : sessionStorage.getItem("processingStatus");

      this.salesContact = !sessionStorage.getItem("salesContact")
        ? null
        : sessionStorage.getItem("salesContact");

      this.projectNumber =
        !this.projectNumber || this.projectNumber.trim() === ""
          ? null
          : this.projectNumber;

      this.debtorNumber =
        !sessionStorage.getItem("debtorNumber") ||
        sessionStorage.getItem("debtorNumber").trim() === ""
          ? null
          : sessionStorage.getItem("debtorNumber");

      this.customerName =
        !sessionStorage.getItem("customer") ||
        sessionStorage.getItem("customer").trim() === ""
          ? null
          : sessionStorage.getItem("customer").trim().toLowerCase();

      this.serviceOrder =
        !sessionStorage.getItem("serviceOrder") ||
        sessionStorage.getItem("serviceOrder").trim() === ""
          ? null
          : sessionStorage.getItem("serviceOrder").trim().toLowerCase();

      this.offerNumber =
        !sessionStorage.getItem("offerNumber") ||
        sessionStorage.getItem("offerNumber").trim() === ""
          ? null
          : sessionStorage.getItem("offerNumber");

      this.offerAmount =
        !sessionStorage.getItem("offerAmount") ||
        sessionStorage.getItem("offerAmount").trim() === ""
          ? null
          : sessionStorage
              .getItem("offerAmount")
              .replaceAll(".", "")
              .replaceAll(",", ".");

      this.effectiveDate =
        !sessionStorage.getItem("effectiveDate") ||
        sessionStorage.getItem("effectiveDate").trim() === ""
          ? null
          : sessionStorage.getItem("effectiveDate");

      this.dateOfInvoice =
        !sessionStorage.getItem("dateOfInvoice") ||
        sessionStorage.getItem("dateOfInvoice").trim() === ""
          ? null
          : sessionStorage.getItem("dateOfInvoice");

      this.invoiceAmount =
        !sessionStorage.getItem("invoiceAmount") ||
        sessionStorage.getItem("invoiceAmount").trim() === ""
          ? null
          : sessionStorage
              .getItem("invoiceAmount")
              .replaceAll(".", "")
              .replaceAll(",", ".");

      this.billNumber =
        !sessionStorage.getItem("billNumber") ||
        sessionStorage.getItem("billNumber").trim() === ""
          ? null
          : sessionStorage.getItem("billNumber");

      this.trainingnameSales =
        !sessionStorage.getItem("trainingnameSales") ||
        sessionStorage.getItem("trainingnameSales").trim() === ""
          ? null
          : sessionStorage.getItem("trainingnameSales");

      this.projectNumberText =
        !sessionStorage.getItem("projectNumberText") ||
        sessionStorage.getItem("projectNumberText") == "undeined" ||
        !sessionStorage.getItem("projectNumberText").trim() === ""
          ? null
          : sessionStorage.getItem("projectNumberText");

      this.pageIncompleted = 1;
      this.fetchSalesListIncompleted();
    },
    getfiltteredData_completed() {
      this.eventNumber =
        !sessionStorage.getItem("eventNumber") ||
        sessionStorage.getItem("eventNumber").trim() === ""
          ? null
          : sessionStorage.getItem("eventNumber");

      this.country =
        !sessionStorage.getItem("salesCountry") ||
        sessionStorage.getItem("salesCountry").trim() === ""
          ? null
          : sessionStorage.getItem("salesCountry");

      this.salesMonth =
        !sessionStorage.getItem("salesMonth") ||
        sessionStorage.getItem("salesMonth").trim() === ""
          ? null
          : sessionStorage.getItem("salesMonth");

      this.salesSource =
        !sessionStorage.getItem("salesSource") ||
        sessionStorage.getItem("salesSource").trim() === ""
          ? null
          : sessionStorage.getItem("salesSource");

      this.orderDate =
        !sessionStorage.getItem("orderDate") ||
        sessionStorage.getItem("orderDate").trim() === ""
          ? null
          : sessionStorage.getItem("orderDate");

      this.processingStatus =
        !sessionStorage.getItem("processingStatus") ||
        sessionStorage.getItem("processingStatus").trim() === ""
          ? null
          : sessionStorage.getItem("processingStatus");

      this.salesContact = !sessionStorage.getItem("salesContact")
        ? null
        : sessionStorage.getItem("salesContact");

      this.projectNumber =
        !this.projectNumber || this.projectNumber.trim() === ""
          ? null
          : this.projectNumber;

      this.debtorNumber =
        !sessionStorage.getItem("debtorNumber") ||
        sessionStorage.getItem("debtorNumber").trim() === ""
          ? null
          : sessionStorage.getItem("debtorNumber");

      this.customerName =
        !sessionStorage.getItem("customer") ||
        sessionStorage.getItem("customer").trim() === ""
          ? null
          : sessionStorage.getItem("customer").trim().toLowerCase();

      this.serviceOrder =
        !sessionStorage.getItem("serviceOrder") ||
        sessionStorage.getItem("serviceOrder").trim() === ""
          ? null
          : sessionStorage.getItem("serviceOrder").trim().toLowerCase();

      this.offerNumber =
        !sessionStorage.getItem("offerNumber") ||
        sessionStorage.getItem("offerNumber").trim() === ""
          ? null
          : sessionStorage.getItem("offerNumber");

      this.offerAmount =
        !sessionStorage.getItem("offerAmount") ||
        sessionStorage.getItem("offerAmount").trim() === ""
          ? null
          : sessionStorage
              .getItem("offerAmount")
              .replaceAll(".", "")
              .replaceAll(",", ".");

      this.effectiveDate =
        !sessionStorage.getItem("effectiveDate") ||
        sessionStorage.getItem("effectiveDate").trim() === ""
          ? null
          : sessionStorage.getItem("effectiveDate");

      this.dateOfInvoice =
        !sessionStorage.getItem("dateOfInvoice") ||
        sessionStorage.getItem("dateOfInvoice").trim() === ""
          ? null
          : sessionStorage.getItem("dateOfInvoice");

      this.invoiceAmount =
        !sessionStorage.getItem("invoiceAmount") ||
        sessionStorage.getItem("invoiceAmount").trim() === ""
          ? null
          : sessionStorage
              .getItem("invoiceAmount")
              .replaceAll(".", "")
              .replaceAll(",", ".");

      this.billNumber =
        !sessionStorage.getItem("billNumber") ||
        sessionStorage.getItem("billNumber").trim() === ""
          ? null
          : sessionStorage.getItem("billNumber");

      this.projectNumberText =
        !sessionStorage.getItem("projectNumberText") ||
        sessionStorage.getItem("projectNumberText") == "undefined" ||
        !sessionStorage.getItem("projectNumberText").trim() === ""
          ? null
          : sessionStorage.getItem("projectNumberText");

      this.trainingnameSales =
        !sessionStorage.getItem("trainingnameSales") ||
        sessionStorage.getItem("trainingnameSales").trim() === ""
          ? null
          : sessionStorage.getItem("trainingnameSales");

      this.pageCompleted = 1;
      this.fetchSalesListCompleted();
    },

    getfiltteredData_all() {
      this.eventNumber =
        !sessionStorage.getItem("eventNumber") ||
        sessionStorage.getItem("eventNumber").trim() === ""
          ? null
          : sessionStorage.getItem("eventNumber");

      this.country =
        !sessionStorage.getItem("salesCountry") ||
        sessionStorage.getItem("salesCountry").trim() === ""
          ? null
          : sessionStorage.getItem("salesCountry");

      this.salesMonth =
        !sessionStorage.getItem("salesMonth") ||
        sessionStorage.getItem("salesMonth").trim() === ""
          ? null
          : sessionStorage.getItem("salesMonth");

      this.salesSource =
        !sessionStorage.getItem("salesSource") ||
        sessionStorage.getItem("salesSource").trim() === ""
          ? null
          : sessionStorage.getItem("salesSource");

      this.orderDate =
        !sessionStorage.getItem("orderDate") ||
        sessionStorage.getItem("orderDate").trim() === ""
          ? null
          : sessionStorage.getItem("orderDate");

      this.processingStatus =
        !sessionStorage.getItem("processingStatus") ||
        sessionStorage.getItem("processingStatus").trim() === ""
          ? null
          : sessionStorage.getItem("processingStatus");

      this.salesContact = !sessionStorage.getItem("salesContact")
        ? null
        : sessionStorage.getItem("salesContact");

      this.projectNumber =
        !this.projectNumber || this.projectNumber.trim() === ""
          ? null
          : this.projectNumber;

      this.debtorNumber =
        !sessionStorage.getItem("debtorNumber") ||
        sessionStorage.getItem("debtorNumber").trim() === ""
          ? null
          : sessionStorage.getItem("debtorNumber");

      this.customerName =
        !sessionStorage.getItem("customer") ||
        sessionStorage.getItem("customer").trim() === ""
          ? null
          : sessionStorage.getItem("customer").trim().toLowerCase();

      this.serviceOrder =
        !sessionStorage.getItem("serviceOrder") ||
        sessionStorage.getItem("serviceOrder").trim() === ""
          ? null
          : sessionStorage.getItem("serviceOrder").trim().toLowerCase();

      this.offerNumber =
        !sessionStorage.getItem("offerNumber") ||
        sessionStorage.getItem("offerNumber").trim() === ""
          ? null
          : sessionStorage.getItem("offerNumber");

      this.offerAmount =
        !sessionStorage.getItem("offerAmount") ||
        sessionStorage.getItem("offerAmount").trim() === ""
          ? null
          : sessionStorage
              .getItem("offerAmount")
              .replaceAll(".", "")
              .replaceAll(",", ".");

      this.effectiveDate =
        !sessionStorage.getItem("effectiveDate") ||
        sessionStorage.getItem("effectiveDate").trim() === ""
          ? null
          : sessionStorage.getItem("effectiveDate");

      this.dateOfInvoice =
        !sessionStorage.getItem("dateOfInvoice") ||
        sessionStorage.getItem("dateOfInvoice").trim() === ""
          ? null
          : sessionStorage.getItem("dateOfInvoice");

      this.invoiceAmount =
        !sessionStorage.getItem("invoiceAmount") ||
        sessionStorage.getItem("invoiceAmount").trim() === ""
          ? null
          : sessionStorage
              .getItem("invoiceAmount")
              .replaceAll(".", "")
              .replaceAll(",", ".");

      this.billNumber =
        !sessionStorage.getItem("billNumber") ||
        sessionStorage.getItem("billNumber").trim() === ""
          ? null
          : sessionStorage.getItem("billNumber");

      this.projectNumberText =
        !sessionStorage.getItem("projectNumberText") ||
        sessionStorage.getItem("projectNumberText") == "undefined" ||
        !sessionStorage.getItem("projectNumberText").trim() === ""
          ? null
          : sessionStorage.getItem("projectNumberText");

      this.trainingnameSales =
        !sessionStorage.getItem("trainingnameSales") ||
        sessionStorage.getItem("trainingnameSales").trim() === ""
          ? null
          : sessionStorage.getItem("trainingnameSales");

      this.page = 1;
      this.fetchSalesList();
    },

    clickFilterDropdown(dtOrderValue) {
      this.dtOrder = dtOrderValue;
      eventBus.$emit("clear-filters");
      this.columnHeader = null;
      this.columnSearch = null;
      this.filterTab = false;

      this.country = null;
      this.eventNumber = null;
      this.salesMonth = null;
      this.salesSource = null;
      this.serialNumber = null;
      this.trainingName = null;
      this.customerName = null;
      this.orderDate = null;
      this.salesContact = null;
      this.processingStatus = null;
      this.columnHeader = null;

      // this.inquiryDate = null;
      this.editorName = null;
      this.eventTrainingCategory = null;
      this.vehicleType = null;
      this.projectNumber = null;
      this.debtorNumber = null;

      this.serviceOrder = null;
      this.offerNumber = null;

      this.offerAmount = null;
      this.effectiveDate = null;
      this.dateOfInvoice = null;
      this.invoiceAmount = null;
      this.billNumber = null;
      this.projectNumberText = null;

      // remove all session
      // remove all session storage

      sessionStorage.removeItem("salesMonth");
      sessionStorage.removeItem("salesContact");
      sessionStorage.removeItem("customer");
      sessionStorage.removeItem("salesCountry");
      sessionStorage.removeItem("orderDate");
      sessionStorage.removeItem("effectiveDate");
      sessionStorage.removeItem("dateOfInvoice");
      sessionStorage.removeItem("eventNumber");
      sessionStorage.removeItem("billNumber");
      sessionStorage.removeItem("invoiceAmount");
      sessionStorage.removeItem("offerAmount");
      sessionStorage.removeItem("offerNumber");
      sessionStorage.removeItem("debtorNumber");
      sessionStorage.removeItem("processingStatus");
      sessionStorage.removeItem("salesSource");
      sessionStorage.removeItem("serviceOrder");
      sessionStorage.removeItem("activeTab");
      sessionStorage.removeItem("filter");
      sessionStorage.removeItem("projectNumberText");
      this.filterTab = false;
      if (this.dtOrder == "I") {
        sessionStorage.setItem("activeTab", "I");
        this.fetchSalesListIncompleted();
      } else if (this.dtOrder == "C") {
        sessionStorage.setItem("activeTab", "C");
        this.fetchSalesListCompleted();
      } else if (this.dtOrder == "A") {
        sessionStorage.setItem("activeTab", "A");
        this.fetchSalesList();
      }
    },

    completeStatusMethod(params) {
      let completeStatus = params.data.completeStatus;
      if (completeStatus == true) {
        return "Complated";
      } else return "";
    },
    countryEditor(params) {
      return params.data.country + params.data.editorName;
    },
    designationsFieldEventNumber(params) {
      if (params.data.eventNumber) {
        let eventNumber = params.data.eventNumber;
        //                 let language = this.$locale;
        //               if (language === "en") {
        //     eventNumber = eventNumber.replace("Vorg_", "GB_"); // UK
        // } else if (language === "pl") {
        //     eventNumber = eventNumber.replace("Vorg_", "PL_"); // Poland
        // } else if (language === "fr") {
        //     eventNumber = eventNumber.replace("Vorg_", "FR_"); // France
        // } else if (language === "hu") {
        //     eventNumber = eventNumber.replace("Vorg_", "HU_"); // Hungary
        // } else if (language === "es") {
        //     eventNumber = eventNumber.replace("Vorg_", "ES_"); // Spain
        // } else if (language === "ru") {
        //     eventNumber = eventNumber.replace("Vorg_", "RU_"); // Russia
        // } else if (language === "kk") {
        //     eventNumber = eventNumber.replace("Vorg_", "KZ_"); // Kazakhstan
        // } else if (language === "it") {
        //     eventNumber = eventNumber.replace("Vorg_", "IT_"); // Italy
        // } else if (language === "de") {
        //     eventNumber = eventNumber.replace("Vorg_", "DE_"); // Germany
        // }

        return `<div style="font-size: 13px; line-height: 14px; color: #5B5B5B; padding-bottom: 5px;">${eventNumber}</div>`;
      }
    },

    onFilterChanged(columnHeader, columnSearch) {
      if (
        !sessionStorage.getItem("salesMonth") &&
        !sessionStorage.getItem("salesContact") &&
        !sessionStorage.getItem("customer") &&
        !sessionStorage.getItem("salesCountry") &&
        !sessionStorage.getItem("orderDate") &&
        !sessionStorage.getItem("effectiveDate") &&
        !sessionStorage.getItem("dateOfInvoice") &&
        !sessionStorage.getItem("eventNumber") &&
        !sessionStorage.getItem("billNumber") &&
        !sessionStorage.getItem("invoiceAmount") &&
        !sessionStorage.getItem("offerAmount") &&
        !sessionStorage.getItem("offerNumber") &&
        !sessionStorage.getItem("debtorNumber") &&
        !sessionStorage.getItem("processingStatus") &&
        !sessionStorage.getItem("salesSource") &&
        !sessionStorage.getItem("serviceOrder") &&
        !sessionStorage.getItem("projectNumberText") &&
        !sessionStorage.getItem("trainingnameSales")
      ) {
        sessionStorage.removeItem("filter");
        this.filterTab = false;
      } else {
        this.filterTab = true;
        sessionStorage.setItem("filter", "filter");
      }
      this.page = 1;
      this.columnHeader = columnHeader;
      this.columnSearch = columnSearch;
      if (this.columnHeader === "eventNumber") {
        this.eventNumber = this.columnSearch;
      }
      if (this.columnHeader === "country") {
        this.country = this.columnSearch;
      }

      if (this.columnHeader === "salesMonth") {
        this.salesMonth = this.columnSearch.toString();
      }
      //  if (this.columnHeader === "inquiryDate") {
      //   this.inquiryDate = this.columnSearch;
      // }
      if (this.columnHeader === "salesSource") {
        this.salesSource = this.columnSearch;
      }
      if (this.columnHeader === "orderDate") {
        this.orderDate = this.columnSearch;
      }

      if (this.columnHeader === "processingStatus") {
        this.processingStatus = this.columnSearch;
      }
      if (this.columnHeader === "editorName") {
        this.editorName = this.columnSearch;
      }
      if (this.columnHeader === "trainingSales") {
        this.trainingName = this.columnSearch;
      }

      if (this.columnHeader === "eventTrainingCategory") {
        this.eventTrainingCategory = this.columnSearch;
      }

      if (this.columnHeader === "vehicleType") {
        this.vehicleType = this.columnSearch;
      }

      if (this.columnHeader === "salesContact") {
        this.salesContact = this.columnSearch;
      }

      if (this.columnHeader === "projectNumber") {
        this.projectNumber = this.columnSearch;
      }

      if (this.columnHeader === "debtorNumber") {
        this.debtorNumber = this.columnSearch;
      }

      if (this.columnHeader === "debtorNumber") {
        this.debtorNumber = this.columnSearch;
      }

      if (this.columnHeader === "customer") {
        this.customerName = this.columnSearch;
      }

      if (this.columnHeader === "serviceOrder") {
        this.serviceOrder = this.columnSearch;
      }

      if (this.columnHeader === "offerNumber") {
        this.offerNumber = this.columnSearch;
      }

      if (this.columnHeader === "offerAmount") {
        this.offerAmount = this.columnSearch;
      }

      if (this.columnHeader === "effectiveDate") {
        this.effectiveDate = this.columnSearch;
      }

      if (this.columnHeader === "dateOfInvoice") {
        this.dateOfInvoice = this.columnSearch;
      }

      if (this.columnHeader === "invoiceAmount") {
        this.invoiceAmount = this.columnSearch;
      }

      if (this.columnHeader === "billNumber") {
        this.billNumber = this.columnSearch;
      }

      if (this.columnHeader === "serialNumber") {
        this.serialNumber = this.columnSearch;
      }

      if (this.columnHeader === "project.projectNumber") {
        this.projectNumberText = this.columnSearch;
      }

      if (this.columnHeader === "trainingnameSales") {
        this.trainingnameSales = this.columnSearch;
      }

      this.trainingnameSales =
        !this.trainingnameSales || this.trainingnameSales.trim() === ""
          ? null
          : this.trainingnameSales;

      this.projectNumberText =
        !this.projectNumberText || this.projectNumberText.trim() === ""
          ? null
          : this.projectNumberText;

      this.eventNumber =
        !this.eventNumber || this.eventNumber.trim() === ""
          ? null
          : this.eventNumber;
      this.country =
        !this.country || this.country.trim() === "" ? null : this.country;

      this.salesMonth =
        !this.salesMonth || this.salesMonth.trim() === ""
          ? null
          : this.salesMonth;

      // this.inquiryDate =
      //   (!this.inquiryDate || this.inquiryDate.trim() === "")
      //     ? null
      //     : this.inquiryDate;

      this.salesSource =
        !this.salesSource || this.salesSource.trim() === ""
          ? null
          : this.salesSource;

      this.orderDate =
        !this.orderDate || this.orderDate.trim() === "" ? null : this.orderDate;

      this.processingStatus =
        !this.processingStatus || this.processingStatus.trim() === ""
          ? null
          : this.processingStatus;

      this.editorName =
        !this.editorName || this.editorName.trim() === ""
          ? null
          : this.editorName;

      this.trainingName =
        !this.trainingName || this.trainingName.trim() === ""
          ? null
          : this.trainingName;

      this.eventTrainingCategory =
        !this.eventTrainingCategory || this.eventTrainingCategory.trim() === ""
          ? null
          : this.eventTrainingCategory;

      this.vehicleType =
        !this.vehicleType || this.vehicleType.trim() === ""
          ? null
          : this.vehicleType;

      this.salesContact = !this.salesContact ? null : this.salesContact;

      this.projectNumber =
        !this.projectNumber || this.projectNumber.trim() === ""
          ? null
          : this.projectNumber;

      this.debtorNumber =
        !this.debtorNumber || this.debtorNumber.trim() === ""
          ? null
          : this.debtorNumber;

      this.customerName =
        !this.customerName || this.customerName.trim() === ""
          ? null
          : this.customerName.trim().toLowerCase();

      this.serviceOrder =
        !this.serviceOrder || this.serviceOrder.trim() === ""
          ? null
          : this.serviceOrder.trim().toLowerCase();

      this.offerNumber =
        !this.offerNumber || this.offerNumber.trim() === ""
          ? null
          : this.offerNumber;

      this.offerAmount =
        !this.offerAmount || this.offerAmount.trim() === ""
          ? null
          : this.offerAmount.replaceAll(".", "").replaceAll(",", ".");

      this.effectiveDate =
        !this.effectiveDate || this.effectiveDate.trim() === ""
          ? null
          : this.effectiveDate;

      this.dateOfInvoice =
        !this.dateOfInvoice || this.dateOfInvoice.trim() === ""
          ? null
          : this.dateOfInvoice;

      this.invoiceAmount =
        !this.invoiceAmount || this.invoiceAmount.trim() === ""
          ? null
          : this.invoiceAmount.replaceAll(".", "").replaceAll(",", ".");

      this.billNumber =
        !this.billNumber || this.billNumber.trim() === ""
          ? null
          : this.billNumber;

      this.serialNumber =
        !this.serialNumber || this.serialNumber.trim() === ""
          ? null
          : this.serialNumber;

      if (this.dtOrder == "I") {
        this.pageIncompleted = 1;
        this.fetchSalesListIncompleted();
      } else if (this.dtOrder == "C") {
        this.pageCompleted = 1;
        this.fetchSalesListCompleted();
      } else if (this.dtOrder == "A") {
        this.page = 1;
        this.fetchSalesList();
      }
    },
    clearFilters() {
      eventBus.$emit("clear-filters");
      this.projectNumberText = null;
      this.country = null;
      this.eventNumber = null;
      this.salesMonth = null;
      this.salesSource = null;
      this.serialNumber = null;
      this.trainingName = null;
      this.customerName = null;
      this.orderDate = null;
      this.salesContact = null;
      this.processingStatus = null;
      this.columnHeader = null;
      this.columnSearch = null;

      // this.inquiryDate = null;
      this.editorName = null;
      this.eventTrainingCategory = null;
      this.vehicleType = null;
      this.projectNumber = null;
      this.debtorNumber = null;
      this.serviceOrder = null;
      this.offerNumber = null;

      this.offerAmount = null;
      this.effectiveDate = null;
      this.dateOfInvoice = null;
      this.invoiceAmount = null;
      this.billNumber = null;
      this.projectNumberText = null;

      // remove all session storage

      sessionStorage.removeItem("salesMonth");
      sessionStorage.removeItem("salesContact");
      sessionStorage.removeItem("customer");
      sessionStorage.removeItem("salesCountry");
      sessionStorage.removeItem("orderDate");
      sessionStorage.removeItem("effectiveDate");
      sessionStorage.removeItem("dateOfInvoice");
      sessionStorage.removeItem("eventNumber");
      sessionStorage.removeItem("billNumber");
      sessionStorage.removeItem("invoiceAmount");
      sessionStorage.removeItem("offerAmount");
      sessionStorage.removeItem("offerNumber");
      sessionStorage.removeItem("debtorNumber");
      sessionStorage.removeItem("processingStatus");
      sessionStorage.removeItem("salesSource");
      sessionStorage.removeItem("serviceOrder");
      sessionStorage.removeItem("activeTab");
      sessionStorage.removeItem("filter");
      sessionStorage.removeItem("projectNumberText");

      this.filterTab = false;

      //  if(this.dtOrder == 'I'){
      this.pageIncompleted = 1;
      this.fetchSalesListIncompleted();
      //    } else if(this.dtOrder == 'C') {
      this.pageCompleted = 1;
      this.fetchSalesListCompleted();
      //   } else if(this.dtOrder == 'A') {
      this.page = 1;
      this.fetchSalesList();
      // }
    },

    designationsField(params) {
      if (params.data.eventTrainingCategory) {
        return `<div class="sales-vehicle-type-text">${
          params.data.vehicleType ? params.data.vehicleType : ""
        }</div>
        <div>${
          params.data.eventTrainingCategory.designationsMap[this.$i18n.locale]
            ? params.data.eventTrainingCategory.designationsMap[
                this.$i18n.locale
              ]
            : ""
        }</div>`;
      } else if (params.data.trainingSales) {
        return `<div class="sales-vehicle-type-text">${
          params.data.vehicleType ? params.data.vehicleType : ""
        }</div>
        <div>${
          params.data.trainingSales.designationsMap[this.$i18n.locale]
            ? params.data.trainingSales.designationsMap[this.$i18n.locale]
            : ""
        }</div>`;
      } else if (
        params.data.otherTraining &&
        !params.data.eventTrainingCategory &&
        !params.data.trainingSales
      ) {
        return `<div class="sales-vehicle-type-text">${
          params.data.vehicleType ? params.data.vehicleType : ""
        }</div>
        <div>${
          params.data.otherTraining ? params.data.otherTraining : ""
        }</div>`;
      } else if (
        params.data.vehicleType &&
        !params.data.otherTraining &&
        !params.data.eventTrainingCategory &&
        !params.data.trainingSales
      ) {
        return `<div class="sales-vehicle-type-text">${
          params.data.vehicleType ? params.data.vehicleType : ""
        }</div>`;
      } else {
        return "";
      }
    },

    getStatusWithHighlight(params) {
      if (params.data.formattedProcessingSatatus == "In_progress") {
        return this.$t("in_progress");
      }
      if (params.data.formattedProcessingSatatus == "Open") {
        return this.$t("opens");
      }
      if (params.data.formattedProcessingSatatus == "Operations") {
        return this.$t("operation");
      }
      if (params.data.formattedProcessingSatatus == "Offer_sent") {
        return this.$t("offer_sent");
      }
      if (params.data.formattedProcessingSatatus == "Quotation") {
        return this.$t("quotation");
      }
      if (params.data.formattedProcessingSatatus == "Order_received") {
        return this.$t("order_received");
      }
      if (params.data.formattedProcessingSatatus == "On_hold") {
        return this.$t("on_hold");
      }
      if (params.data.formattedProcessingSatatus == "Invoicing") {
        return this.$t("invoicing");
      }
      if (params.data.formattedProcessingSatatus == "Open_training") {
        return this.$t("open_training");
      }
      if (params.data.formattedProcessingSatatus == "Invoice_created") {
        return this.$t("invoice_created");
      }
    },
    getFormattedSalesMonth(params) {
      if (params.data.salesMonth != null) {
        let dateFormatted = new Date(params.data.salesMonth).toLocaleDateString(
          this.$i18n.locale,
          {
            year: "numeric",
            month: "long",
          }
        );

        return dateFormatted;
      }
    },
    previousPage() {
      this.page = this.page - 1;
      this.fetchSalesList();
    },
    nextPage() {
      this.page = this.page + 1;
      this.fetchSalesList();
    },
    showCurrentPage(pageNumber) {
      this.page = pageNumber;
      this.fetchSalesList();
    },

    previousPageCompleted() {
      this.pageCompleted = this.pageCompleted - 1;
      this.fetchSalesListCompleted();
    },
    nextPageCompleted() {
      this.pageCompleted = this.pageCompleted + 1;
      this.fetchSalesListCompleted();
    },
    showCurrentPageCompleted(pageNumber) {
      this.pageCompleted = pageNumber;
      this.fetchSalesListCompleted();
    },

    previousPageIncompleted() {
      this.pageIncompleted = this.pageIncompleted - 1;
      this.fetchSalesListIncompleted();
    },
    nextPageIncompleted() {
      this.pageIncompleted = this.pageIncompleted + 1;
      this.fetchSalesListIncompleted();
    },
    showCurrentPageIncompleted(pageNumber) {
      this.pageIncompleted = pageNumber;
      this.fetchSalesListIncompleted();
    },

    onError(err) {
      if (
        err.response != null &&
        err.response.data != null &&
        err.response.data.message != null
      ) {
        this.$noty.error(err.response.data.message);
      } else {
        console.error(err);
      }
    },
    fetchSalesList() {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get(this.routes.salesList, {
          params: {
            search: _this.search,
            sort: _this.sort,
            order: _this.order ? "ASC" : "DESC",
            page: _this.page - 1,
            size: _this.ElementPerPage,
            eventNumber: _this.eventNumber,
            salesSource: _this.salesSource,
            country: _this.country,
            salesMonth: _this.salesMonth,
            serialNumber: _this.serialNumber,
            trainingName: _this.trainingnameSales,
            customerName: _this.customerName,
            orderDate: _this.orderDate,
            salesContact: _this.salesContact,
            processingStatus: _this.processingStatus,

            projectNumberText: _this.projectNumberText,
            editorName: _this.editorName,
            eventTrainingCategory: _this.eventTrainingCategory,
            vehicleType: _this.vehicleType,
            projectNumber: _this.projectNumber,
            debtorNumber: _this.debtorNumber,
            serviceOrder: _this.serviceOrder,
            offerNumber: _this.offerNumber,
            offerAmount: _this.offerAmount,
            effectiveDate: _this.effectiveDate,
            dateOfInvoice: _this.dateOfInvoice,
            invoiceAmount: _this.invoiceAmount,
            billNumber: _this.billNumber,
          },
        })
        .then(function (response) {
          _this.salesList = response.data.content;
          _this.currentPageRecordCount = _this.salesList.length;
          _this.totalRecords = response.data.totalElements;
          _this.totalPages = response.data.totalPages;
          _this.rowData = _.cloneDeep(_this.salesList);
          if (_this.gridApi) {
            _this.gridApi.setRowData(_this.rowData);
          }
          _this.$forceUpdate();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    fetchSalesListNoFilter() {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get(this.routes.salesList, {
          params: {
            sort: _this.sort,
            order: _this.order ? "ASC" : "DESC",
            page: _this.page - 1,
            size: _this.ElementPerPage,
          },
        })
        .then(function (response) {
          _this.salesList = response.data.content;
          _this.currentPageRecordCount = _this.salesList.length;
          _this.totalRecords = response.data.totalElements;
          _this.totalPages = response.data.totalPages;
          _this.rowData = _.cloneDeep(_this.salesList);
          if (_this.gridApi) {
            _this.gridApi.setRowData(_this.rowData);
          }
          _this.$forceUpdate();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    fetchSalesListCompleted() {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get(this.routes.salesList, {
          params: {
            search: _this.search,
            sort: _this.sortCompleted,
            order: _this.orderCompleted ? "ASC" : "DESC",
            page: _this.pageCompleted - 1,
            size: _this.ElementPerPage,
            eventNumber: _this.eventNumber,
            salesSource: _this.salesSource,
            country: _this.country,
            salesMonth: _this.salesMonth,
            serialNumber: _this.serialNumber,
            trainingName: _this.trainingnameSales,
            customerName: _this.customerName,
            orderDate: _this.orderDate,
            salesContact: _this.salesContact,
            processingStatus: _this.processingStatus,
            projectNumberText: _this.projectNumberText,
            editorName: _this.editorName,
            eventTrainingCategory: _this.eventTrainingCategory,
            vehicleType: _this.vehicleType,
            projectNumber: _this.projectNumber,
            debtorNumber: _this.debtorNumber,
            serviceOrder: _this.serviceOrder,
            offerNumber: _this.offerNumber,
            offerAmount: _this.offerAmount,
            effectiveDate: _this.effectiveDate,
            dateOfInvoice: _this.dateOfInvoice,
            invoiceAmount: _this.invoiceAmount,
            billNumber: _this.billNumber,
            completedStatus: true,
          },
        })
        .then(function (response) {
          _this.salesListCompleted = response.data.content;
          _this.currentPageRecordCountCompleted =
            _this.salesListCompleted.length;
          _this.totalRecordsCompleted = response.data.totalElements;
          _this.totalPagesCompleted = response.data.totalPages;
          _this.rowDataCompleted = _.cloneDeep(_this.salesListCompleted);
          if (_this.gridApiCompleted) {
            _this.gridApiCompleted.setRowData(_this.rowDataCompleted);
          }
          _this.$forceUpdate();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    fetchSalesListCompletedNoFilter() {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get(this.routes.salesList, {
          params: {
            search: _this.search,
            sort: _this.sortCompleted,
            order: _this.orderCompleted ? "ASC" : "DESC",
            page: _this.pageCompleted - 1,
            size: _this.ElementPerPage,
            completedStatus: true,
          },
        })
        .then(function (response) {
          _this.salesListCompleted = response.data.content;
          _this.currentPageRecordCountCompleted =
            _this.salesListCompleted.length;
          _this.totalRecordsCompleted = response.data.totalElements;
          _this.totalPagesCompleted = response.data.totalPages;
          _this.rowDataCompleted = _.cloneDeep(_this.salesListCompleted);
          if (_this.gridApiCompleted) {
            _this.gridApiCompleted.setRowData(_this.rowDataCompleted);
          }
          _this.$forceUpdate();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    fetchSalesListIncompleted() {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get(this.routes.salesList, {
          params: {
            search: _this.search,
            sort: _this.sortIncompleted,
            order: _this.orderIncompleted ? "ASC" : "DESC",
            page: _this.pageIncompleted - 1,
            size: _this.ElementPerPage,
            eventNumber: _this.eventNumber,
            salesSource: _this.salesSource,
            country: _this.country,
            salesMonth: _this.salesMonth,
            serialNumber: _this.serialNumber,
            trainingName: _this.trainingnameSales,
            customerName: _this.customerName,
            orderDate: _this.orderDate,
            salesContact: _this.salesContact,
            processingStatus: _this.processingStatus,
            projectNumberText: _this.projectNumberText,
            editorName: _this.editorName,
            eventTrainingCategory: _this.eventTrainingCategory,
            vehicleType: _this.vehicleType,
            projectNumber: _this.projectNumber,
            debtorNumber: _this.debtorNumber,
            serviceOrder: _this.serviceOrder,
            offerNumber: _this.offerNumber,
            offerAmount: _this.offerAmount,
            effectiveDate: _this.effectiveDate,
            dateOfInvoice: _this.dateOfInvoice,
            invoiceAmount: _this.invoiceAmount,
            billNumber: _this.billNumber,
            completedStatus: false,
          },
        })
        .then(function (response) {
          _this.salesListIncompleted = response.data.content;
          _this.currentPageRecordCountIncompleted =
            _this.salesListIncompleted.length;
          _this.totalRecordsIncompleted = response.data.totalElements;
          _this.totalPagesIncompleted = response.data.totalPages;
          _this.rowDataIncompleted = _.cloneDeep(_this.salesListIncompleted);
          if (_this.gridApiIncompleted) {
            _this.gridApiIncompleted.setRowData(_this.rowDataIncompleted);
          }
          _this.$forceUpdate();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    fetchSalesListIncompletedNoFilter() {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get(this.routes.salesList, {
          params: {
            search: _this.search,
            sort: _this.sortIncompleted,
            order: _this.orderIncompleted ? "ASC" : "DESC",
            page: _this.pageIncompleted - 1,
            size: _this.ElementPerPage,
            completedStatus: false,
          },
        })
        .then(function (response) {
          _this.salesListIncompleted = response.data.content;
          _this.currentPageRecordCountIncompleted =
            _this.salesListIncompleted.length;
          _this.totalRecordsIncompleted = response.data.totalElements;
          _this.totalPagesIncompleted = response.data.totalPages;
          _this.rowDataIncompleted = _.cloneDeep(_this.salesListIncompleted);
          if (_this.gridApiIncompleted) {
            _this.gridApiIncompleted.setRowData(_this.rowDataIncompleted);
          }
          _this.$forceUpdate();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    onFinally() {
      showLoadingCircle(false);
    },
    onCellClicked(params) {
      const rowData = params.data;
      this.$router.push("/sales-request?salesListId=" + rowData.id);
    },

    onGridReady(params) {
      this.gridApi = params.api;
      //this.gridApi.sizeColumnsToFit();
    },
    onGridReadyCompleted(params) {
      this.gridApiCompleted = params.api;
      //this.gridApi.sizeColumnsToFit();
    },
    onGridReadyIncompleted(params) {
      this.gridApiIncompleted = params.api;
      //this.gridApi.sizeColumnsToFit();
    },
    initializeScrollbar() {
      // Delay execution to ensure DOM is updated after tab change
      this.$nextTick(() => {
        setTimeout(() => {
          // Small delay to allow new tab content to load
          const gridContainer = this.$el.querySelector(
            ".grid-container.v-window-item--active"
          );
          const gridBody = this.$el.querySelector(
            ".v-window-item--active .ag-root"
          );
          const horizontalScrollbar = this.$el.querySelector(
            ".v-window-item--active .ag-body-horizontal-scroll"
          );
          const threshold = 100; // Distance from bottom to switch to relative position

          if (!gridContainer || !gridBody || !horizontalScrollbar) {
            return;
          }

          const updateScrollbarPosition = () => {
            const rect = gridContainer.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const footerHeight = 50;
            const pageBottom = document.documentElement.scrollHeight;
            const scrollPosition = window.scrollY + windowHeight;
            if (scrollPosition < pageBottom - footerHeight) {
              horizontalScrollbar.style.display = "block";
              horizontalScrollbar.classList.add("sticky-scrollbar");
              horizontalScrollbar.classList.remove("relative-scrollbar");
              horizontalScrollbar.style.bottom = "0px";
            } else if (scrollPosition >= pageBottom - footerHeight) {
              horizontalScrollbar.classList.add("relative-scrollbar");
              horizontalScrollbar.classList.remove("sticky-scrollbar");
              if (window.innerWidth > 1024) {
                horizontalScrollbar.style.bottom = "40px";
              } else {
                horizontalScrollbar.style.bottom = "0px";
              }
            } else {
              horizontalScrollbar.style.display = "block";
              horizontalScrollbar.classList.add("sticky-scrollbar");
              horizontalScrollbar.classList.remove("relative-scrollbar");
              horizontalScrollbar.style.bottom = "0px";
            }
          };

          const synchronizeScroll = (event) => {
            gridBody.scrollLeft = event.target.scrollLeft;
          };

          const throttle = (func, limit) => {
            let lastFunc;
            let lastRan;
            return function () {
              const context = this;
              const args = arguments;
              if (!lastRan) {
                func.apply(context, args);
                lastRan = Date.now();
              } else {
                clearTimeout(lastFunc);
                lastFunc = setTimeout(() => {
                  if (Date.now() - lastRan >= limit) {
                    func.apply(context, args);
                    lastRan = Date.now();
                  }
                }, limit - (Date.now() - lastRan));
              }
            };
          };

          window.addEventListener(
            "scroll",
            throttle(updateScrollbarPosition, 100)
          );
          window.addEventListener("resize", () => {
            horizontalScrollbar.style.width = `${gridBody.scrollWidth}px`;
            updateScrollbarPosition();
          });
          horizontalScrollbar.addEventListener("scroll", synchronizeScroll);

          horizontalScrollbar.style.width = `${gridBody.scrollWidth}px`;
          updateScrollbarPosition();
        }, 100); // Small delay (100ms) to wait for DOM update
      });
    },

    handlePageScroll() {
      const gridHeader = document.querySelector(
        ".v-window-item.v-window-item--active .ag-header"
      );
      const gridContainer = document.querySelector(".grid-container");
      const gridBody = document.querySelector(
        ".v-window-item.v-window-item--active .ag-body-viewport"
      );

      if (gridHeader) {
        const scrollPosition =
          window.scrollY || document.documentElement.scrollTop;

        if (scrollPosition > this.stickyThreshold) {
          gridHeader.classList.add("header_stick");

          //Add the .grid_stick class to the .grid-container when the header is sticky
          if (gridContainer) {
            gridContainer.classList.add("grid_stick");
          }
          if (gridBody) {
            gridBody.classList.add("body_height");
          }
        } else {
          gridHeader.classList.remove("header_stick");

          // Remove the .grid_stick class when the header is no longer sticky
          if (gridContainer) {
            gridContainer.classList.remove("grid_stick");
          }
          if (gridBody) {
            gridBody.classList.remove("body_height");
          }
        }
      }
      this.$nextTick(() => {
        this.initializeScrollbar();
      });
    },
    onFirstDataRendered(params) {
      //   params.api.sizeColumnsToFit(); // Resize columns to fit the grid width
    },

    getJsonOptions() {
      const options = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      return options;
    },
    currencyFormatter(currency, sign) {
      if (currency) {
        var sansDec = currency.toFixed(0);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return sign + `${formatted}`;
      } else {
        return "";
      }
    },
    getOfferAmount(params) {
      if (params.data.offerAmount) {
        return "€ " + this.formatToEuropeanAmount(params.data.offerAmount);
      } else {
        return "";
      }
    },

    getInvoiceAmount(params) {
      if (params.data.invoiceAmount) {
        return "€ " + this.formatToEuropeanAmount(params.data.invoiceAmount);
      } else {
        return "";
      }
    },
    formatToEuropeanAmount(input) {
      try {
        let cleanedInput = input
          .trim()
          .replace(/€/g, "")
          .replace(/,/g, "")
          .replace(/;/g, "");
        let number = parseFloat(cleanedInput);
        if (isNaN(number)) {
          throw new Error("Invalid input: not a number");
        }
        return new Intl.NumberFormat("de-DE").format(number);
      } catch (error) {
        console.error(error.message);
        return null;
      }
    },
    onResize() {
      setTimeout(() => {
        if (this.gridApiIncompleted) {
          this.gridApiIncompleted.refreshHeader();
          this.gridApiIncompleted.refreshCells({ force: true });
          this.gridApiIncompleted.doLayout(); // Forces grid layout recalculation
          this.gridApiIncompleted.redrawRows(); // Refresh rows
        }

        if (this.gridOptions && this.gridOptions.api) {
          this.gridOptions.api.refreshHeader();
          this.gridOptions.api.refreshCells({ force: true });
          this.gridOptions.api.doLayout();
          this.gridOptions.redrawRows(); // Refresh rows
        }

        if (this.gridOptionsCompleted && this.gridOptionsCompleted.api) {
          this.gridOptionsCompleted.api.refreshHeader();
          this.gridOptionsCompleted.api.refreshCells({ force: true });
          this.gridOptionsCompleted.api.doLayout();
          this.gridOptionsCompleted.redrawRows(); // Refresh rows
        }
      }, 200); // Delay to allow resize calculations
    },
  },
  beforeDestroy() {
    // Clean up the scroll event listener
    window.removeEventListener("scroll", this.handlePageScroll);
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style scoped>
.v-dialog > .v-card > .v-card__actions {
  padding: 8px 16px;
}
</style>
